/**
 * Page de connexion.
 */
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, isAuthenticated, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  // Rediriger vers le dashboard si l'utilisateur est déjà connecté
  useEffect(() => {
    if (!authLoading && isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, authLoading, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      if (result.requires_2fa) {
        // Rediriger vers la page de vérification 2FA
        navigate('/verify-2fa', { state: { email: result.email } });
      } else {
        // Login normal, rediriger vers le dashboard
        navigate('/dashboard');
      }
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="auth-page">
      {/* Navbar similaire à la page d'accueil */}
      <nav className="auth-navbar">
        <div className="auth-nav-container">
          <Link to="/" className="auth-nav-logo">
            <img src="/images/logo_transparent.png" alt="Crions D'Couleurs" className="logo-img" />
            <span className="logo-text">Crions D'Couleurs</span>
          </Link>

          <div className="auth-nav-menu">
            <Link to="/" className="auth-nav-link">Accueil</Link>
            <Link to="/sejours" className="auth-nav-link">Séjours</Link>
            <Link to="/register" className="auth-nav-btn">S'inscrire</Link>
          </div>
        </div>
      </nav>

      {/* Conteneur principal avec formulaire */}
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1 className="auth-title">Connexion</h1>
            <p className="auth-subtitle">Bienvenue ! Connectez-vous pour accéder à votre espace</p>
          </div>

          <form className="auth-form" onSubmit={handleSubmit}>
            {error && (
              <div className="auth-error">
                {error}
              </div>
            )}

            <div className="form-group">
              <label htmlFor="email" className="form-label">
                Adresse email
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                className="form-input"
                placeholder="votre@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password" className="form-label">
                Mot de passe
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                className="form-input"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <div className="form-link-container">
              <Link to="/forgot-password" className="form-link">
                Mot de passe oublié ?
              </Link>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="auth-button"
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>

            <div className="auth-footer">
              <p className="auth-footer-text">
                Pas encore de compte ?{' '}
                <Link to="/register" className="auth-footer-link">
                  S'inscrire
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
